@if (btnType() && size() && color()) {
  <button [pTooltip]="!disabled() ? tooltip() : ''" tooltipPosition="top"
          [class.rotate]="rotate()" [class.active]="active()" [class.disabled]="disabled()"
          [ngClass]="[btnType(), size(), color()]"
          (click)="!disabled() ? animate() : ''">
    <ng-content></ng-content>
    @if (icon()) {
      <i [ngClass]="['pi pi-' + icon(), iconSize() ?? '', iconColor() ?? '']"></i>
    }
  </button>
}
